<template>
  <section :class="['px-5 md:p-12.5 lg:p-25 transition-[padding_gap]']">
    <TitleBlock
      :title="content.title"
      :description="content.description"
      :center="true"
      :class="{ 'px-5 ml-0 lg:-order-1': content.reverse }"
    />
    <ul
      :class="[
        'grid grid-cols-1 sm:grid-cols-2 gap-8 lg:gap-25 mx-auto w-fit',
        { 'md:grid-cols-3': content.max_per_row > 2 && content.items.length > 2 },
        { 'lg:grid-cols-4': content.max_per_row > 3 && content.items.length > 3 },
        { 'xl:grid-cols-5': content.max_per_row > 4 && content.items.length > 4 },
      ]"
    >
      <RichCard v-for="(card, index) in content.items" :key="index" :content="card" />
    </ul>
  </section>
</template>
<script lang="ts">
import { TitleBlock } from "@/components/blocks";
import { RichCard } from "@/components/cards";

export default {
  name: "RichCardsSection",
  components: { TitleBlock, RichCard },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
};
</script>
